import React from 'react';
import DataGrid, { Column, ColumnOrColumnGroup, DataGridProps } from 'react-data-grid';
import ColumnsSetting from './ColumnsSetting';
import ReactPaginate from 'react-paginate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

export type NTADataGridColumnProps<R, SR = unknown> = Column<R, SR>;

export interface NTADataGridProps<R, SR, K extends string | number> extends Omit<DataGridProps<R, SR, K>, 'columns'> {
  columnsKeyConfig: string;
  columns: NTADataGridColumnProps<R, SR>[];
  totalRecord?: number;
  onPageChange?: (selectedItem: { selected: number }) => void;
  pageIndex?: number | null | undefined;
  pageSize?: number;
}

export default function NtaDataGrid<R, SR = unknown, K extends string | number = number>({
  columns,
  columnsKeyConfig,
  totalRecord,
  onPageChange,
  pageIndex,
  pageSize,
  ...props
}: NTADataGridProps<R, SR, K>) {
  const [columnsWithConfig, setColumnsWidthConfig] = React.useState<Column<R, SR>[]>(columns as any);

  const onColumnsDisplayChange = (hiddenCols: string[]) => {
    setColumnsWidthConfig(columns.filter(col => !hiddenCols.includes(col.key)));
  };
  const onColumnsChange = (c: Column<R, SR>[]) => {
    setColumnsWidthConfig(c);
  };
  const totalPage = React.useMemo(() => {
    return Math.ceil((totalRecord || 0) / (pageSize || 0));
  }, [totalRecord, pageSize]);
  return (
    <>
      <DataGrid headerRowHeight={60} rowHeight={50} className="rdg-light nta-data-grid omega-scrollbar" columns={columnsWithConfig} {...props} />
      <div className=" agent-dashboard-paginate row x-gap-10 y-gap-10">
        <div className="col-auto">
          <ColumnsSetting
            onColumnsChange={onColumnsChange}
            originColumns={columns as any}
            columns={columnsWithConfig}
            onColumnsDisplayChange={onColumnsDisplayChange}
            columnsKeyConfig={columnsKeyConfig}
          />
        </div>
        {totalRecord ? (
          <>
            <div className="col-auto">
              <div className="total">Total records: {totalRecord}</div>
            </div>
            <div className="col">
              <ReactPaginate
                breakLabel="..."
                previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
                nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
                onPageChange={onPageChange}
                pageRangeDisplayed={5}
                forcePage={(pageIndex || 1) - 1}
                pageCount={totalPage || 0}
                renderOnZeroPageCount={null}
              />
            </div>
          </>
        ) : null}
      </div>
    </>
  );
}
